export default {
  skills: []
}
